import React, { useEffect, useRef } from "react";
import html2canvas from "html2canvas";
import { saveAs } from "file-saver";
import { QRCodeCanvas } from "qrcode.react";
import moment from "moment-timezone";
const { apiForImages } = require("../services/requests");

const DownloadCarteiras = ({ carteira, setComponenteRenderizado }) => {
  const ref = useRef(null);
  const url_atual = window.location.href;
  const carteiraAntiga = "31/03/2025";
  const carteiraAtual = moment(carteira.dataValidade)
    .utcOffset("-0000")
    .format("DD/MM/YYYY");

  useEffect(() => {
    const picture = () => {
      const node = document.getElementById("download_carteira");

      html2canvas(node, {
        allowTaint: true,
        useCORS: true,
      }).then((canvas) => {
        const base64URl = canvas
          .toDataURL("image/jpeg")
          .replace("image/jpeg", "image/octet-stream");
        saveAs(base64URl, `${carteira.codigoUso}.jpeg`);
      });
    };

    picture();
    setComponenteRenderizado(false);
  }, [carteira.codigoUso, setComponenteRenderizado]);

  return (
    <div className="flex justify-center items-center min-h-screen p-4 bg-gray-100">
      <div
        ref={ref}
        id="download_carteira"
        className={`m-0 p-0 rounded-lg w-[390px] h-[844px] sm:w-[350px] sm:h-[750px] md:w-[390px] md:h-[844px] lg:w-[420px] lg:h-[900px] ${
            carteiraAtual > carteiraAntiga 
              ? "bg-green-200" 
              : "bg-blue-100"
          }`}
          style={{
            background: carteiraAtual > carteiraAntiga 
              ? "hsl(156, 39.20%, 75.50%)"
              : "hsl(194, 100.00%, 62.90%) 0%"
          }}
      >
      {/* Seção dos logos */}
      <div className="pt-8 sm:pt-6 md:pt-8 lg:pt-12 px-3 sm:px-4 md:px-5 flex justify-around items-center">
        <img 
          className="w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 object-contain" 
          src={`${apiForImages}/images/DNE.png`} 
          alt="dne" 
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
        {carteiraAtual > carteiraAntiga ? (
          <div>
            <img
              className="w-28 h-auto sm:w-32 sm:h-auto md:w-36 md:h-auto object-contain"
              src={`${apiForImages}/images/2025.png`}
              alt="logo_unisc"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          </div>
        ) : (
          <div className="flex flex-col">
            <img
              className="w-28 h-auto sm:w-32 sm:h-auto md:w-36 md:h-auto mb-1 sm:mb-2 md:mb-2.5 object-contain"
              src={`${apiForImages}/images/logo_unisc.png`}
              alt="logo_unisc"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <img
              className="w-28 h-auto sm:w-32 sm:h-auto md:w-36 md:h-auto object-contain"
              src={`${apiForImages}/images/2024.png`}
              alt="logo_2024"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          </div>
        )}
      </div>

      {/* Seção da foto e QR Code */}
      <div className="flex justify-around mt-6 sm:mt-8 md:mt-10 px-3 sm:px-4 md:px-5">
        <img src={carteira.foto} className="w-28 h-auto sm:w-32 sm:h-auto md:w-36 md:h-auto rounded-lg" alt="foto_aluno" />
        <div>
          <div className="flex items-center justify-center bg-white rounded-lg p-1">
            <QRCodeCanvas
              className="rounded-lg"
              value={url_atual}
              marginSize={2}
              size={100}
              style={{
                width: '100%',
                height: 'auto',
                maxWidth: '100px',
                maxHeight: '100px'
              }}
            />
          </div>
          <div className="flex flex-col text-center font-calibri font-bold mt-1">
            <span className="text-sm sm:text-base md:text-lg mb-[-8px] sm:mb-[-10px]">COD. DE USO</span>
            <span className="text-lg sm:text-xl md:text-2xl font-medium">{carteira.codigoUso}</span>
          </div>
        </div>
      </div>

      {/* Seção dos dados do estudante */}
      <div 
        className={`rounded-2xl ml-3 sm:ml-4 md:ml-5 mt-6 sm:mt-7 md:mt-8 w-[320px] h-[320px] sm:w-[300px] sm:h-[300px] md:w-[350px] md:h-[350px] lg:w-[380px] lg:h-[380px] relative p-px ${
          carteiraAtual > carteiraAntiga 
            ? "bg-white-200" 
            : "bg-white-100"
        }`}
        style={{
          background: carteiraAtual > carteiraAntiga 
            ? "rgba(201, 231, 218, 0.63)" 
            : "rgba(252, 250, 251, 0.63)"
        }}
      >
        {/* Overlay com opacidade */}
        <div 
          className="absolute inset-0 rounded-2xl"
          style={{
            backgroundColor: "hsla(240, 2.70%, 92.70%, 0.13)"
          }}
        ></div>
        
        {/* Conteúdo dos dados */}
        <div className="relative z-10 pl-2 sm:pl-3 md:pl-4 h-full py-2 sm:py-3 md:py-4">
          <div className="flex flex-col font-calibri font-medium mb-0.5 sm:mb-1">
            <span className="mb-0 text-xs sm:text-sm md:text-md">Nome:</span>
            <span className="m-0 text-sm sm:text-base md:text-lg break-words">{carteira.name}</span>
          </div>
          <div className="flex flex-col font-calibri font-medium mb-0.5 sm:mb-1">
            <span className="mb-0 text-xs sm:text-sm md:text-md">Instituição de ensino:</span>
            <span className="m-0 text-sm sm:text-base md:text-lg break-words">{carteira.instituicaoEnsino}</span>
          </div>
          <div className="flex flex-col font-calibri font-medium mb-0.5 sm:mb-1">
            <span className="mb-0 text-xs sm:text-sm md:text-md">Curso:</span>
            <span className="m-0 text-sm sm:text-base md:text-lg break-words">{carteira.curso}</span>
          </div>
          <p className="font-calibri font-medium text-xs sm:text-sm md:text-md mb-0.5 sm:mb-1">Documentos:</p>
          <div className="font-calibri font-medium mb-0.5 sm:mb-1">
            <span className="mb-0 text-xs sm:text-sm md:text-md">CPF:</span>
            <span className="m-0 text-sm sm:text-base md:text-lg break-words">{carteira.cpf}</span>
          </div>
          <div className="font-calibri font-medium mb-0.5 sm:mb-1">
            <span className="mb-0 text-xs sm:text-sm md:text-md">RG:</span>
            <span className="m-0 text-sm sm:text-base md:text-lg break-words">{carteira.rg}</span>
          </div>
          <div className="font-calibri font-medium mb-0.5 sm:mb-1">
            <span className="mb-0 text-xs sm:text-sm md:text-md">Data Nasc: </span>
            <span className="m-0 text-sm sm:text-base md:text-lg break-words">{carteira.dataNascimento}</span>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default DownloadCarteiras;
